<template>
  <div id="cost-section">
    <v-stepper-content :step="step">
      <CostSectionParallax
        :description="costSection.description"
        :title="costSection.name"
        :banner="costSection.banner"
        :step="step"
      />

      <Costs
        v-for="(cost, i) in costs"
        :key="i"
        :cost="cost"
        @update-visibility="cost.visible = !cost.visible"
        @delete-cost="initiateDeleteCost(i)"
      />

      <v-layout row justify-space-around>
        <v-flex grow class="pl-3">
          <v-text-field
            placeholder="Add a New Cost"
            v-model="newCost.name"
            @keyup.enter="initiateAddNewCost"
          ></v-text-field>
        </v-flex>
        <v-flex shrink class="pr-3">
          <v-btn depressed @click="initiateAddNewCost" outlined color="green lighten-1" :disabled="!addNewCostTitleExists">
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <h2 class="has-margin-1 text-center">Total {{costSection.name}} Costs: ${{ costSectionTotal }}</h2>

      <v-layout row justify-center wrap>
        <v-btn text @click="returnToPreviousCostSection" v-if="index > 0" class="ma-1">
          <v-icon dark left>arrow_back</v-icon>Back
        </v-btn>
        <v-btn depressed @click="initiateCostReset" class="ma-1">Reset {{costSection.name}} Costs</v-btn>
        <v-btn depressed dark color="blue lighten-1" @click.native="updateStep" class="ma-1">
          {{ nextButton }}
          <v-icon small right v-if="step === 5">fas fa-check-circle</v-icon>
        </v-btn>
      </v-layout>
    </v-stepper-content>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Costs from "@/components/Calculator/Costs";
import CostSectionParallax from "@/components/Calculator/CostSectionParallax";
import GeneralService from "@/services/GeneralService";

export default {
  name: "cost-section",
  components: {
    Costs,
    CostSectionParallax,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 2,
    },
  },
  data: () => ({
    reset: false,
    newCost: {
      name: "",
      total: 0,
      verified: false,
      visible: true,
      deleted: false,
      color: "",
      subCosts: [
        {
          name: "Design Engineering",
          value: null,
        },
        {
          name: "Purchasing",
          value: null,
        },
        {
          name: "Production",
          value: null,
        },
        {
          name: "Accounting",
          value: null,
        },
        {
          name: "Finance",
          value: null,
        },
        {
          name: "Quality",
          value: null,
        },
        {
          name: "Materials",
          value: null,
        },
        {
          name: "Sales & Marketing",
          value: null,
        },
        {
          name: "Other",
          value: null,
        },
      ],
    },
  }),
  computed: {
    step() {
      return this.index + 1;
    },
    nextButton() {
      return this.step === 5 ? "Submit" : "Continue";
    },
    costSection() {
      return this.$store.state.costSections[this.index];
    },
    costs() {
      return this.costSection.costs;
    },
    costSectionTotal() {
      const costTotals = this.costs.map(cost => {
        const values = cost.subCosts.map(subCost => {
          return subCost.value ? Number(subCost.value) : 0;
        });
        return values.reduce(GeneralService.reducer);
      });
      if (costTotals.length !== 0) {
        const total = costTotals.reduce(GeneralService.reducer);
        return GeneralService.dollarFormatted(total);
      } else {
        return 0;
      }
    },
    addNewCostTitleExists() {
      return !!this.newCost.name;
    },
  },
  watch: {
    costSectionTotal: {
      handler(val) {
        this.$emit('update-total', val);
      },
    },
  },
  methods: {
    ...mapActions([
      "addNewCost",
      "deleteCost",
      "resetCostSection",
    ]),
    initiateCostReset() {
      const costSectionIndex = this.index;
      const costSectionName = this.costSection.name;
      this.resetCostSection({ costSectionIndex, costSectionName });
    },
    initiateAddNewCost() {
      const index = this.index,
      newCost = this.newCost;
      this.addNewCost({ index, newCost });
      this.newCost = {
        name: "",
        total: 0,
        verified: false,
        visible: true,
        deleted: false,
        color: "",
        subCosts: [
          {
            name: "Design Engineering",
            value: null
          },
          {
            name: "Purchasing",
            value: null
          },
          {
            name: "Production",
            value: null
          },
          {
            name: "Accounting",
            value: null
          },
          {
            name: "Finance",
            value: null
          },
          {
            name: "Quality",
            value: null
          },
          {
            name: "Materials",
            value: null
          },
          {
            name: "Sales & Marketing",
            value: null
          },
          {
            name: "Other",
            value: null
          }
        ]
      };
    },
    initiateDeleteCost(index) {
      const costIndex = index,
        costSectionIndex = this.index;
      this.deleteCost({ costSectionIndex, costIndex });
    },
    returnToPreviousCostSection() {
      this.$emit("return-to-previous-cost-section");
    },
    updateStep() {
      if (this.step === 5) {
        this.$emit("verify-cost-section", 5);
        this.$router.push({
          name: "summary-dashboard",
          params: {
            thePage: 3
          },
        });
      } else {
        const nextStep = this.step + 1;
        this.$emit("update-step", nextStep, this.costSectionTotal);
      }
    },
  },
};
</script>
